module.exports = __webpack_public_path__ + "static/media/oversized-mat-photo-frame-3.57dece28.jpg";